import logo from "../../assets/preact.svg"
import {Button} from "@/components/ui/button.tsx";
import {toggleMode} from "@/main.tsx";
import {toast} from "sonner";

interface NavbarProps {
    setFullScreen: (s: boolean) => void
}

/**
 * Navbar component
 */
export function Navbar({ setFullScreen }: NavbarProps) {
    const handleFullScreen = () => {
        setFullScreen(true)
        toast.message("Mode Plein écran. Tapez ou cliquez sur l'écran pour quittez ce mode")
    }

    return <header className="fixed top-0 left-0 w-full h-[80px] flex items-center justify-between px-20 border-b bg-(--bg-blur) backdrop-filter backdrop-blur-xl z-[100] max-[955px]:px-10 max-[440px]:px-4">
        <div className="flex gap-2 items-center">
            <img src={logo} alt="logo" />
            <p className="font-bold text-[18px] max-[440px]:text-[15px]">Numeric Clock</p>
        </div>
        <div className="flex gap-20 items-center">
            <div>
                <Button
                    className="cursor-pointer text-[16px] mr-4 max-[630px]:hidden"
                    variant="link"
                    onClick={() => toggleMode(document.body.classList.contains("dark") ? "remove" : "add")}
                >
                    Changer de mode
                </Button>
                <Button className="cursor-pointer text-[16px]" onClick={handleFullScreen}>Plein écran</Button>
            </div>
        </div>
    </header>
}
